import { Component, input } from '@angular/core';
import { FaDuotoneIconComponent } from "@fortawesome/angular-fontawesome";
import { ThemeService } from '../../core/services/theme.service';
import { AsyncPipe } from '@angular/common';

@Component({
  selector: 'ms-theme-switcher',
  imports: [FaDuotoneIconComponent, AsyncPipe],
  templateUrl: './theme-switcher.html',
})
export class ThemeSwitcher {
  public colorClass = input<string | null>();
  public currentTheme$;
  public isDarkThemeActive$;

  constructor(private themeService: ThemeService) {
    this.currentTheme$ = this.themeService.currentTheme$;
    this.isDarkThemeActive$ = this.themeService.isDarkThemeActive$;
  }

  public setTheme(theme: string): void {
    this.themeService.setTheme(theme);
  }

}
